import { render, staticRenderFns } from "./TuitionPaymentStudent.vue?vue&type=template&id=da66d986&"
import script from "./TuitionPaymentStudent.vue?vue&type=script&lang=js&"
export * from "./TuitionPaymentStudent.vue?vue&type=script&lang=js&"
import style0 from "./TuitionPaymentStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports